interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, total: number): (number | "...")[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages: (number | "...")[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  const baseBtn =
    "min-w-[36px] h-9 px-2 rounded-md text-sm flex items-center justify-center transition-colors duration-200";

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer`}
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {pages.map((p, idx) =>
        p === "..." ? (
          <span key={`ellipsis-${idx}`} className="px-1 text-foreground-400">
            ...
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`${baseBtn} cursor-pointer ${
              p === page
                ? "bg-primary-500 text-background-50 font-semibold"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
            aria-current={p === page ? "page" : undefined}
          >
            {p}
          </button>
        )
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer`}
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}